import {isNonEmptyString, isNullOrUndefined} from "../services/Validator";

// Used to provide DateTime related helping functions

// ---- Format DateTime to yyyy/mm/dd hh:mm:ss format
export function formatDateTime(date) {
    // Defensive
    if (!(date instanceof Date))
        return null

    // Format
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month start at 0 => Add 1
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    // Return
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

// ---- Format ISO date to DD/MM/YY format
export function formatIsoDateToDDMMYY(isoDate) {

    // Format
    const date = new Date(isoDate);
    const day = String(date.getDate()).padStart(2, '0'); // Ajoute un zéro devant si nécessaire
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Les mois sont indexés de 0 à 11
    const year = String(date.getFullYear()).slice(-2); // Prend les deux derniers chiffres de l'année

    // Return
    return `${day}/${month}/${year}`;
}
// ---- Get today date without time : YYYY-MM-DD
export function todayDateString() {
    const today = new Date();
    return today.toISOString().split('T')[0]
}

// ---- Get day after input dateString => YYYY-MM-DD
export function addOneDayToDateString(dateString) {
    if (isNullOrUndefined(dateString) || isNonEmptyString(dateString))
        return null
    const date = new Date(dateString); // Créer une nouvelle instance de Date à partir de la chaîne
    date.setDate(date.getDate() + 1); // Ajouter un jour
    return date.toISOString().split('T')[0]; // Retourner la date au format YYYY-MM-DD
}

// ---- Get number of days before given dateString => YYYY-MM-DD
export function subtractDaysToDayString(dateString, days) {
    if (isNullOrUndefined(dateString) || isNullOrUndefined(days) || !isNonEmptyString(dateString))
        return null
    const date = new Date(dateString); // Créer une nouvelle instance de Date à partir de la chaîne
    date.setDate(date.getDate() - days); // Soustraire le nombre de jours
    return date.toISOString().split('T')[0]; // Retourner la date au format YYYY-MM-DD
}

// ---- Convert dateString into DateTime object
export function convertDateStringIntoDateTime(dateString) {
    return new Date(dateString)
}